import React, { FC } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { ActionableSelectOption } from 'components/ActionableSelect/ActionableSelect';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

interface LoansAutocompleteProps {
  areLoansLoading: boolean;
  selectedLoan: ActionableSelectOption | null;
  parsedLoans: ActionableSelectOption[];
  handleSearchChange: (value: string) => void;
  handleOnChangeLoan: (value: ActionableSelectOption) => void;
}

const LoansAutocomplete: FC<LoansAutocompleteProps> = ({
  areLoansLoading,
  selectedLoan,
  parsedLoans,
  handleSearchChange,
  handleOnChangeLoan,
}) => {
  return (
    <Autocomplete
      value={selectedLoan}
      loading={areLoansLoading}
      options={
        selectedLoan && !parsedLoans.some(option => option.id === selectedLoan.id)
          ? [selectedLoan, ...parsedLoans]
          : [...parsedLoans]
      }
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField {...params} label='Salesforce Loan' variant='outlined' style={{ width: 300 }} />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          {option.onClick ? (
            <Box
              display={'flex'}
              alignItems={'center'}
              onClick={event => {
                event.stopPropagation();
                option.onClick && option.onClick();
              }}
            >
              <AddRoundedIcon sx={{ color: '#265183', marginRight: '8px' }} />
              {option.label}
            </Box>
          ) : (
            option.label
          )}
        </li>
      )}
      onInputChange={(event, value) => {
        handleSearchChange(value);
      }}
      onChange={(event, value) => {
        if (value) {
          handleOnChangeLoan(value);
        }
      }}
    />
  );
};

export default LoansAutocomplete;
